// extracted by mini-css-extract-plugin
export var option = "_cw-0";
export var optionCard = "_cw-f";
export var optionContent = "_cw-g";
export var optionIcon = "_cw-i";
export var optionIconBox = "_cw-h";
export var optionLabel = "_cw-j";
export var optionPill = "_cw-m";
export var optionPillBadge = "_cw-p";
export var optionPillIcon = "_cw-n";
export var optionPillLabel = "_cw-o";
export var optionRadio = "_cw-k";
export var optionRadioInner = "_cw-l";
export var optionReveal = "_cw-2";
export var optionRevealDelay0 = "_cw-3";
export var optionRevealDelay1 = "_cw-4";
export var optionRevealDelay10 = "_cw-d";
export var optionRevealDelay11 = "_cw-e";
export var optionRevealDelay2 = "_cw-5";
export var optionRevealDelay3 = "_cw-6";
export var optionRevealDelay4 = "_cw-7";
export var optionRevealDelay5 = "_cw-8";
export var optionRevealDelay6 = "_cw-9";
export var optionRevealDelay7 = "_cw-a";
export var optionRevealDelay8 = "_cw-b";
export var optionRevealDelay9 = "_cw-c";
export var optionSelected = "_cw-1";